import { render, staticRenderFns } from "./Pfarreien.vue?vue&type=template&id=e68a1b68&scoped=true&"
import script from "./Pfarreien.vue?vue&type=script&lang=js&"
export * from "./Pfarreien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68a1b68",
  null
  
)

export default component.exports